import { BillingErrorProps } from '~/types/checkout';

export function setFormErrors(
  errors: BillingErrorProps | string,
  ref: any,
): boolean {
  if (typeof errors === 'string') return false;

  const {
    country: countryErrors,
    postal_code: postalCodeErrors,
    tax_id: taxIdErrors,
    tax_business_name: taxBusinessNameErrors,
  } = errors || {};

  const errorList = [];
  const minErrorValue = 0; // SonarLint :/

  if (!ref?.current) return false;

  if (countryErrors?.length || 0 > minErrorValue) {
    errorList.push({ key: 'country', message: countryErrors?.[0] });
  }

  if (postalCodeErrors?.length || 0 > minErrorValue) {
    errorList.push({ key: 'postal_code', message: postalCodeErrors?.[0] });
  }

  if (taxIdErrors?.length || 0 > minErrorValue) {
    errorList.push({ key: 'tax_id', message: taxIdErrors?.[0] });
  }

  if (taxBusinessNameErrors?.length || 0 > minErrorValue) {
    errorList.push({
      key: 'tax_business_name',
      message: taxBusinessNameErrors?.[0],
    });
  }

  errorList.forEach(({ key, message }) => {
    ref?.current?.setError(key, {
      type: 'custom',
      message,
    });
  });

  return !!errorList.length;
}
